var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms-container" }, [
    _c(
      "p",
      { staticClass: "is-size-7 has-text-grey-light" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "has-text-grey-light",
            attrs: { target: "_blank", href: "https://www.touchpoint.io/terms" }
          },
          [_vm._v("\n\t\t\tTerms of Service\n\t\t")]
        ),
        _vm._v("\n\t\tand\n\t\t"),
        _c(
          "a",
          {
            staticClass: "has-text-grey-light",
            attrs: {
              target: "_blank",
              href: "https://www.touchpoint.io/privacy"
            }
          },
          [_vm._v("\n\t\t\tPrivacy Policy\n\t\t")]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc211a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc211a9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseTermsBlurb.vue
// module id = null
// module chunks = 